import type { ITranslater, ISelectOptionWithGroup } from '@/pages/intelligence/types/common';

export const getChildOptions = (
  parentValue: string,
  childOptionsMap?: { [key: string]: ISelectOptionWithGroup[] },
  cfg?: { isTranslate: boolean; translater: ITranslater },
): ISelectOptionWithGroup[] => {
  const { isTranslate, translater } = cfg ?? {};
  const childOptions = childOptionsMap?.[parentValue] ?? [];
  if (!isTranslate || typeof translater !== 'function') return childOptions;
  return childOptions?.map((item) => {
    const translateText = translater?.({ id: item?.label as string });
    return {
      ...item,
      text: translateText,
    };
  });
};
